import { createFileRoute } from "@tanstack/react-router";

import { ReleaseUpdatesSettingsPanel } from "../components/settings/ReleaseUpdatesSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

export const Route = createFileRoute("/settings/updates")({
  // Ungated by any account: the Application Release Check reads a public index (ADR-0104).
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/updates"),
  component: ReleaseUpdatesSettingsPanel,
});
